import script from "./UserTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__